import React from "react";
import {
  arrayOf,
  bool,
  elementType,
  node,
  oneOfType,
  string
} from "prop-types";

import * as S from "./styled";

const ListItem = ({ as, children, isRaw, itemName, link, title, ...props }) => (
  <S.ListItem as={as} name={itemName}>
    {isRaw ? (
      title
    ) : (
      <S.ListItemLink {...props} href={link}>
        {title}
        {children}
      </S.ListItemLink>
    )}
  </S.ListItem>
);

ListItem.propTypes = {
  isRaw: bool,
  itemName: string,
  link: string,
  title: oneOfType([node, string, arrayOf(node)]).isRequired,
  as: oneOfType([string, elementType]),
  children: node
};

ListItem.defaultProps = {
  isRaw: false,
  itemName: undefined,
  link: "#",
  as: "li",
  children: null
};

export default ListItem;
